import { createApp } from "vue";
import App from "./App.vue";
import Globe from "globe.gl";
import makeServer from "./mock-server";
import store from "./store";
import Framework7 from "framework7/lite-bundle";
import Framework7Vue, { registerComponents } from "framework7-vue/bundle";
Framework7.use(Framework7Vue);
import "framework7/framework7-bundle.css";
import "framework7-icons";

// Creates a mock server if in development
// WIP: need to figure out if this still works
if (process.env.MOCK_SERVER == "yes") {
  makeServer();
}
// Creates the Vue App instance using the App.vue component as the main component
const app = createApp(App).use(store);
// register all Framework7 Vue components by passing Vue app instance there
registerComponents(app);
// Global properties
app.config.globalProperties.$myGlobe = Globe();
app.config.globalProperties.$appName = "Envelop";
// Mounts the app instance to the <div id="app"> element in the /public/index.html file
app.mount("#app");
